import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// 获取设备参数集合
export function getEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/params',
    method: 'GET',
    params: parameter
  })
}
// 保存设备参数
export function saveEquipmentParameters (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/equipment/param',
    method: 'POST',
    data: parameter
  })
}
